import env from '../config/env';
import { getService, postBodyService } from "./base.service";
import config from "../config/application";
import permission from '../api/permissions.service';
import dictionary from '../config/dictionary'

//url
const readTemplate = 'find_all';
const readDetail = 'find_detail_by_template';
const addTemplate = 'add';
const updateTemplate = 'update';
const deleteTemplate = 'delete';
const deleteDetail = 'disable_detail';
const updateDetail = 'update_detail';
const addDetail = 'add_detail';

class TemplateService {
    getTemplates() {
        const url = `${config.data.configuration.template.url}${readTemplate}`;
        return getService(url);

    } 

    async getDetail(username, templateId) {
        let valid = await permission.validPermission(
            env.transaction.template,
            username,
            env.app.systemCode, dictionary.configApp.action.list);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.template.url}${readDetail}/${templateId}`;
            return getService(url);
        } else {
            return valid;
        }
    }
    async addTemplate(template, username) {
        let valid = await permission.validPermission(
            env.transaction.template,
            username,
            env.app.systemCode, dictionary.configApp.action.add);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.template.url}${addTemplate}`;

            return postBodyService(url, template);
        } else {
            return valid;
        }
    }
    async updateTemplate(template, username) {
        let valid = await permission.validPermission(
            env.transaction.template,
            username,
            env.app.systemCode, dictionary.configApp.action.edit);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.template.url}${updateTemplate}`;

            return postBodyService(url, template);
        } else {
            return valid;
        }
    }

    async deleteTemplate(lsData, username) {
        let valid = await permission.validPermission(
            env.transaction.template,
            username,
            env.app.systemCode, dictionary.configApp.action.delete);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.template.url}${deleteTemplate}`;
            return postBodyService(url, lsData);
        } else {
            return valid;
        }
    }

    async deleteDetail(lsData, username) {
        let valid = await permission.validPermission(
            env.transaction.template,
            username,
            env.app.systemCode, dictionary.configApp.action.delete);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.template.url}${deleteDetail}`;
            return postBodyService(url, lsData);
        } else {
            return valid;
        }
    }
    async updateDetail(detail, username) {
        let valid = await permission.validPermission(
            env.transaction.template,
            username,
            env.app.systemCode, dictionary.configApp.action.edit);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.template.url}${updateDetail}`;

            return postBodyService(url, detail);
        } else {
            return valid;
        }
    }
    async addDetail(detail, username) {
        let valid = await permission.validPermission(
            env.transaction.template,
            username,
            env.app.systemCode, dictionary.configApp.action.add);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.template.url}${addDetail}`;

            return postBodyService(url, detail);
        } else {
            return valid;
        }
    }
}

export default new TemplateService();